export const resume_categories = [
  { value: 'Commercial', key: 'Commercial' },
  { value: 'Film', key: 'Film' },
  { value: 'Television', key: 'Television' },
  { value: 'Theatre', key: 'Theatre' },
  { value: 'Print / Fashion', key: 'Print / Fashion' },
  { value: 'Training', key: 'Training' },
  { value: 'Voice', key: 'Voice' },
  { value: 'Stunt', key: 'Stunt' },
  { value: 'Corporate', key: 'Corporate' },
  { value: 'MC/Presenting', key: 'MC/Presenting' },
  { value: 'Extras', key: 'Extras' },
  { value: 'Other', key: 'Other' },
  { value: 'Dance', key: 'Dance' },
  { value: 'Singing', key: 'Singing' },
];
